var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 38,
    fill: "none",
    viewBox: "0 0 194 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1DE0FE",
    d: "m32.303 18.657-16.152 9.31L0 37.275V0l16.152 9.31zM64.606 18.657l-16.151 9.31-16.152 9.309V0l16.152 9.31zM96.91 18.657l-16.153 9.31-16.151 9.309V0l16.151 9.31zM129.213 18.657l-16.152 9.31-16.151 9.309V0l16.151 9.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1DE0FE",
    d: "m161.516 18.657-16.152 9.31-16.152 9.309V0l16.152 9.31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1DE0FE",
    d: "m193.819 18.657-16.151 9.31-16.152 9.309V0l16.152 9.31z"
  })));
};
export default SvgArrows;